import React, { useEffect, useState } from "react";
import Navbar from "../src/components/Navbar";
import Hero from "../src/components/Hero";
import Statbar from "../src/components/Statbar";
import About from "../src/components/About";
import Team from "../src/components/Team";
import Contact from "../src/components/Contact";
import Footer from "../src/components/Footer";
import Sessions from "../src/components/Sessions";
import Modal from "../src/components/Modal";
import CourseList from "../src/components/CourseList";
import Sponsors from "../src/components/Sponsors";
import Photos from "../src/components/Photos";
import classesData from "./data/classes.json";
import classesTakenData from "./data/classes_taken.json";


import "./App.css";

function App() {
  const SHEETDB_URL = "https://sheetdb.io/api/v1/62a4b36cw11xu";

  const [loading, setLoading] = useState(false);

  // This state now holds BOTH "joined" and "request" types from your Google Sheet
  const [registrations, setRegistrations] = useState([]);

  const [studentId, setStudentId] = useState("");
  const [activeId, setActiveId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [classes, setClasses] = useState(classesData);
  const [classesTaken, setClassesTaken] = useState(classesTakenData);


  const handleLogin = async (id) => {
    if (!id || id.length < 3) {
      alert("Please enter a valid Student ID");
      return;
    }

    // Set the active ID first so the UI shifts
    setActiveId(id);

    // Now call the API only because someone logged in
    try {
      const res = await fetch(SHEETDB_URL);
      const data = await res.json();
      setRegistrations(data);
    } catch (err) {
      console.error("Error fetching registrations:", err);
    }
  };

  // One function to handle both "Join" and "Request"
  const handleAction = async (classId, type) => {
    if (!activeId) return alert("Please enter your ID!");

    const entry = {
      studentId: activeId,
      classId: classId,
      type: type, // 'joined' or 'request'
      timestamp: new Date().toLocaleString(),
    };

    try {
      const response = await fetch(SHEETDB_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: [entry] }),
      });

      if (response.ok) {
        setRegistrations((prev) => [...prev, entry]);
      }
    } catch (err) {
      alert("Error saving to Google Sheets");
    }
  };

  const getStudentData = () => {
    // Get IDs of classes taken (empty array if not logged in)
    const takenIds = activeId
      ? classesTaken
          .filter((r) => r.studentId === activeId)
          .map((r) => r.classId)
      : [];

    return {
      taken: classes.filter((c) => takenIds.includes(c.id)),
      // This will now be full of classes even if activeId is null
      available: classes.filter(
        (c) => c.isScheduled && !takenIds.includes(c.id)
      ),
      upcoming: classes.filter(
        (c) => !c.isScheduled && !takenIds.includes(c.id)
      ),
    };
  };

  const { taken, available, upcoming } = getStudentData();

  if (loading) return <p className="loading-text">Loading...</p>;

  return (
    <>
      <Navbar />
      <Hero />
      <Statbar />
      <Sponsors />
      <About />
      <Team />
      

      <div style={{ padding: "4rem 2rem", textAlign: "center" }}>
        <h2 style={{ color: "var(--gold)" }}>Explore Our Curriculum</h2>
        <div style={{ maxWidth: "800px", margin: "0 auto 2.5rem auto" }}>
          <p
            style={{
              color: "var(--text)",
              fontSize: "1.25rem",
              lineHeight: "1.6",
              marginBottom: "1rem",
            }}
          >
            With <strong>over 30 class sessions</strong> dedicated to mastering
            every aspect of
            <span style={{ color: "var(--gold)", fontWeight: "bold" }}>
              {" "}
              FIRST Tech Challenge
            </span>
            , we guide students on a journey from{" "}
            <span style={{ color: "var(--gold)" }}> novice </span> to
            <span style={{ color: "var(--gold)" }}> expert</span>.
          </p>

          {/* DURATION TEXT ADDED HERE */}
          <p
            style={{
              color: "var(--text)",
              fontSize: "1.1rem",
              marginBottom: "1rem",
            }}
          >
            Each focused session is designed to last
            <span style={{ color: "var(--gold)", fontWeight: "bold" }}>
              {" "}
              30 to 45 minutes.
            </span>
            <br />
            Taught by both Mentors and Students
          </p>
        </div>
        <button className="btn" onClick={() => setIsModalOpen(true)}>
          View Full Course Catalog
        </button>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Full Course Catalog"
      >
        <CourseList classes={classes} />
      </Modal>

      <Sessions
        studentId={studentId}
        setStudentId={setStudentId}
        activeId={activeId}
        onLogin={handleLogin}
        taken={taken}
        available={available}
        upcoming={upcoming}
        registrations={registrations}
        onJoin={(id) => handleAction(id, "joined")}
        onRequest={(id) => handleAction(id, "request")}
      />
      <Photos />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
